module.exports = __webpack_public_path__ + "img/Image.84b19f68.png";